'use client';

import { AccountHoverCard } from '#/components/ethereum/account-hover-card';
import { Badge } from '#/components/ui/badge';
import { useTranslation } from '#/contexts/useTranslation';
import {
  useConfiguredChain,
  useConfiguredChainId,
} from '#/data/wagmi/configured';
import { directStakingConfig } from '#/lib/generated';
import { Translation } from 'intl-lib';

export function ContractAddresses() {
  const translation = useTranslation();
  const chainId = useConfiguredChainId();
  const directStakingAddress = directStakingConfig.address(chainId);
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <span className="uppercase text-sm text-gray-500">
          {translation.EthereumStaking.StakingContract}
        </span>
        <AccountHoverCard
          address={directStakingAddress}
          title={<Translation path="EthereumStaking.StakingContract" />}
        />
      </div>
    </div>
  );
}

export function TestnetBadge() {
  const chain = useConfiguredChain();
  return (
    chain.testnet && (
      <Badge variant="destructive" className="leading-5 align-middle">
        {chain.name}
      </Badge>
    )
  );
}
